import { Directive, HostBinding, Input, OnChanges } from '@angular/core';
import { MatRipple } from '@angular/material/core';

@Directive({
    selector: '[tidyRipple]',
    standalone: false
})
export class TidyRippleDirective extends MatRipple implements OnChanges {
  @Input() desktopAndMobileColor: boolean;

  @HostBinding('class.tidy-ripple-desktop-and-mobile-color') _isToAddColor: boolean;
  @HostBinding('class.tidy-ripple-wrapper')

  ngOnChanges() {
    this._isToAddColor = this.desktopAndMobileColor;
  }
} 
